import { PRODUCT_FIELDS } from "../fields";
import type { DecorationScreenSchema } from "./types";

export const productCardSchema = {
	allergens: { css: [] },
	back_button: { css: [] },
	back_icon: { css: [] },
	back_text: { css: [] },
	badges: { css: [] },
	buy_button: { css: [], variant: { values: ["cart_price", "icon"], default: "cart_price" }, icon: true, locked: true },
	buy_caption: { css: [] },
	buy_icon: { css: [] },
	buy_text: { css: [] },
	card: { css: [] },
	close_button: { css: [] },
	close_icon: { css: [] },
	content: { css: [] },
	controls: { css: ["modifiers"] },
	description: { css: [] },
	description_badge: { css: [], visible: true },
	description_button: { css: [] },
	footer: { css: ["modifiers"] },
	header: { css: [] },
	hero: { css: [] },
	info_button: { css: ["active"], variant: { values: ["modal", "popover"], default: "modal" } },
	info_icon: { css: [] },
	info_nutritions: { css: [] },
	info_popover: { css: [] },
	info_text: { css: [] },
	info_title: { css: [] },
	like_button: { css: [] },
	like_icon: { css: [] },
	modifiers: { css: [], variant: { values: ["sheet", "panel"], default: "sheet" } },
	modifiers_apply: { css: ["ready"], icon: true },
	modifiers_body: { css: [] },
	modifiers_footer: { css: [] },
	modifiers_grid: { css: [] },
	modifiers_header: { css: [] },
	modifiers_inner: { css: [] },
	modifiers_item: { css: ["dimmed", "selected"] },
	modifiers_item_count: { css: [] },
	modifiers_item_image: { css: [] },
	modifiers_item_minus: { icon: true },
	modifiers_item_name: { css: [] },
	modifiers_item_plus: { icon: true },
	modifiers_item_price: { css: [] },
	modifiers_item_radio: { css: ["selected"], icon: true },
	modifiers_item_step: { css: [] },
	modifiers_item_stepper: { css: [] },
	modifiers_notch: { css: [], icon: true },
	modifiers_price: { css: [] },
	modifiers_rule: { css: [] },
	modifiers_rule_badge: { css: ["required"] },
	modifiers_rule_text: { css: [] },
	modifiers_tab: { css: ["active", "required"] },
	modifiers_tab_check: { css: [], icon: true },
	modifiers_tab_count: { css: [] },
	modifiers_tab_dot: { css: [] },
	modifiers_tabs: { css: [] },
	modifiers_title: { css: [] },
	nutrition_basis: { css: [] },
	nutrition_basis_option: { css: ["active"] },
	nutritions: { css: [] },
	nutritions_item: { css: [] },
	options: { css: [] },
	photo: { css: ["modifiers"] },
	photo_scrim: { css: [], visible: true },
	price: { css: [] },
	price_block: { css: ["modifiers"], visible: false },
	quantity: { css: [] },
	quantity_minus: { css: [] },
	quantity_plus: { css: [] },
	quantity_value: { css: [] },
	settings_button: { css: [], variant: { values: ["text", "icon", "icon_text"], default: "text" }, icon: true },
	sheet: { css: [], variant: { values: ["sheet", "modal"], default: "sheet" } },
	size_pill: { css: ["active"], variant: { values: ["stacked", "inline"], default: "stacked" } },
	size_pill_name: { css: [] },
	size_pill_price: { css: [] },
	size_pill_texts: { css: [] },
	sizes: { css: [] },
	swiper: { css: [] },
	title: { css: [], inserts: true, fields: PRODUCT_FIELDS },
	title_text: { css: [] },
	weight: { css: [] },
} as const satisfies DecorationScreenSchema;
